import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDollarCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.70009 9.30001C6.70009 9.55713 6.77633 9.80847 6.91918 10.0223C7.06203 10.236 7.26506 10.4027 7.5026 10.5011C7.74015 10.5995 8.00153 10.6252 8.25371 10.575C8.50588 10.5249 8.73752 10.4011 8.91933 10.2193C9.10114 10.0374 9.22495 9.80581 9.27511 9.55363C9.32527 9.30145 9.29953 9.04007 9.20113 8.80252C9.10274 8.56498 8.93612 8.36195 8.72233 8.2191C8.50855 8.07626 8.25721 8.00001 8.00009 8.00001C7.74298 8.00001 7.49163 7.92377 7.27785 7.78092C7.06407 7.63808 6.89744 7.43504 6.79905 7.1975C6.70065 6.95996 6.67491 6.69857 6.72507 6.44639C6.77523 6.19422 6.89904 5.96258 7.08085 5.78077C7.26266 5.59896 7.4943 5.47515 7.74647 5.42499C7.99865 5.37483 8.26004 5.40057 8.49758 5.49897C8.73512 5.59736 8.93816 5.76399 9.081 5.97777C9.22385 6.19155 9.30009 6.4429 9.30009 6.70001M8 4.53333V5.4M8 10.6V11.4667M1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDollarCircle;
